<template>
  <el-main class="contact">
    <ContentNav
      :bannerTextIMG="require('../assets/contact/bannerText.png')"
      :bannerimgIMG="Url.imgUrl + this.$store.state.NavList[7].banner"
    ></ContentNav>
    <div class="content">
      <div class="Item-from">
        <el-form>
          <el-row class="Item-flex">
            <el-col>
              <el-form-item>
                <el-input
                  class="item-input"
                  v-model="form.username"
                  placeholder="您的姓名"
                ></el-input>
              </el-form-item>
              <el-form-item>
                <el-input placeholder="您的手机号码" v-model="form.phone">
                  <el-button  @click="GetCode(form.phone)" slot="append">{{isSendCode}}</el-button>
                </el-input>
              </el-form-item>
           
              <el-form-item>
                <el-input
                  type="textarea"
                  placeholder="问题概述"
                  v-model="form.problemDes"
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col>
              <el-form-item>
                <el-select
                  v-model="form.advisoryType"
                  placeholder="咨询类别"
                  style="width: 100%"
                >
                   <el-option label="民事" value="38"></el-option>
                    <el-option label="刑事" value="39"></el-option>
                    <el-option label="行政" value="40"></el-option>
                    <el-option label="其他" value="41"></el-option>
                </el-select>
              </el-form-item>
               <el-form-item>
								<el-input placeholder="您收到的验证码" v-model="form.code"></el-input>
								</el-form-item>
                <el-form-item>
                <el-input
                  placeholder="您的位置"
                  v-model="form.address"
                ></el-input>
              </el-form-item>
              <el-form-item>
                <el-button :style="disabled==true? 'background:#888':'' " :disabled="disabled" class="submit" type="primary" @click="onSubmit"
                  >发 送</el-button
                >
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>
      </div>
      <div class="map">
        <img src="../assets/contact/map.png" alt />
      </div>
    </div>
	<Icongroup></Icongroup>
    <!-- 右侧浮动图标组 -->
    <!-- <transition name="el-zoom-in-center">
      <div class="Icon_group" v-if="isDisFloat">
        <div class="Icon_item">
          <a href="tel:0755-33586300"
            ><img
              src="../assets/home/dianhua@3x.png"
              :alt="SystemOption.seoKeyWord"
          /></a>
        </div>
        <div class="Icon_item">
          <img
            @mouseover="isShowWXrcode = true"
            @mouseout="isShowWXrcode = false"
            src="../assets/home/weixin@3x.png"
            :alt="SystemOption.seoKeyWord"
          />
          <img
            v-if="isShowWXrcode"
            style="position: absolute; width: 143px; left: -164px; top: 54px"
            src="../assets/home/wxRode.jpg"
            alt=""
          />
        </div>
        <div class="Icon_item" @click="backtop">
          <img src="../assets/home/top@3x.png" :alt="SystemOption.seoKeyWord" />
        </div>
      </div>
    </transition> -->
  </el-main>
</template>

<script>
import ContentNav from "../components/ContentNav";
import Icongroup from "../components/Icon_group";

export default {
  components: {
	ContentNav,
	Icongroup
  },
  metaInfo() {
    return {
      title: `联系我们-${this.SystemOption.seoTitle ?? ""}`,
      meta: [
        {
          // set meta
          name: "keywords",
          content: this.SystemOption.seoKeyWord,
        },
        {
          // set meta
          name: "description",
          content: this.SystemOption.seoDescribe,
        },
      ],
    };
  },
  data() {
    return {
      select: 1,
      form: {
        //联系我们表单
        username: "",
        phone: "",
        address: "",
        advisoryType: "",
        problemDes: "",
        code: "",
      },
      isSendCode: "发送验证码",
      SystemOption: [], //SEO 配置
		isShowWXrcode: false, //是否悬浮显示微信二维码
    isDisFloat:false,
    disabled:false,

    

    };
  },
 
  methods: {
    // getLocation(){//获取位置
    //  let _this = this;
    //   var aaa=localStorage.getItem("addwww");
    //  _this.form.address=aaa;
    // },
    //回到顶部
    // backtop() {
    //   // document.documentElement.scrollTop = 0;
    //   // document.body.scrollTop = 0;
    //   var timer = setInterval(function () {
    //     let osTop =
    //       document.documentElement.scrollTop || document.body.scrollTop;
    //     let ispeed = Math.floor(-osTop / 5);
    //     document.documentElement.scrollTop = document.body.scrollTop =
    //       osTop + ispeed;
    //     this.isTop = true;
    //     if (osTop === 0) {
    //       clearInterval(timer);
    //     }
    //   }, 10);
    // },
    // //滚动监听方法
    // handleScroll() {
	// 	console.log(document.documentElement.scrollTop ,document.body.scrollTop)
	// 	window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop > 500 ? (this.isDisFloat = true) : (this.isDisFloat = false);
    // },
    //获取验证码
    // GetCode(phone) {
    //   if (this.form.phone == "") {
    //     alert("请填写手机号");
    //     return false;
    //   }
    //   this.isSendCode = "已发送";
    //   this.axios({
    //     type: "get",
    //     url: this.Url.apiUrl + "sms/code/" + this.$store.state.guid + "",
    //     params: {
    //       phone: phone,
    //     },
    //   }).then((res) => {
    //     console.log(res);
    //   });
    // },
     //提交表单
    // onSubmit() {
    //   this.disabled = true;
		// 		this.axios({
		// 			method: 'post',
    //       url: "http://test-shenzhen.api.yingkelawyer.com/api/" + "SystemOption/CaseAdvisory",
		// 			data: this.form,
		// 			headers: {
		// 				'Content-Type': 'application/json'
		// 			},
		// 		}).then(() => {
		// 			alert("已发送")
		// 			this.disabled = true;
		// 		})
    // },
    loadSeo() {
      //获取SEO配置
      this.axios
        .get(this.Url.apiUrl + "SystemOption/GetSystemOption")
        .then((res) => (this.SystemOption = res.data));
    },
   
     //获取随机 guid
    getGuid() {
      function S4() {
        return (((1 + Math.random()) * 0x10000) | 0).toString(16).substring(1);
      }
      return (S4()+S4()+"-"+S4()+"-"+S4()+"-"+S4()+"-"+S4()+S4()+S4());
    },
    //获取验证码
    GetCode(phone) {
      let that = this;
      let guid = that.getGuid();
      that.guid = guid; 
      if (this.form.phone == "") {
        alert("请填写手机号");
        return false;
      }
      this.isSendCode = "已发送";
      this.axios({
        type: "post",
        url: this.Url.apiUrl + "sms/code/"+that.guid+"",//线上地址
        //url: "http://test-shenzhen.api.yingkelawyer.com/api/sms/code/" + guid + "", //测试 44接口地址
       // url: "http://localhost:8094/api/sms/code/" + guid + "", //测试 本地接口地址
        params: {
          phone: phone,
        },
      }).then((res) => {
        console.log(res);
      });
    },
    //提交表单
    onSubmit() {
      let that = this;
      if (this.form.username == "") {
        alert("请输入您的姓名");
        return false;
      }
      if (this.form.advisoryType == "") {
        alert("请选择咨询类别");
        return false;
      }
      if (this.form.phone == "") {
        alert("请填写您的手机号");
        return false;
      }
      if (this.form.code == "") {
        alert("请输入您收到的验证码");
        return false;
      }
      if (this.form.problemDes == "") {
        alert("请输入问题概述");
        return false;
      }
      this.disabled = true;
      //验证输入的验证码是否正确
      if(that.guid==undefined)
      {
      alert("发送失败,请重新输入您的咨询信息");
        return false;
      }
      that.axios({
        type: "post",
        url: this.Url.apiUrl + "v/code/"+that.guid+"",//线上地址
       //  url: "http://test-shenzhen.api.yingkelawyer.com/api/v/code/"+that.guid+"",//////////////////////////测试 44接口地址
         //url: "http://localhost:8094/api/v/code/"+that.guid+"",//////////////////////////测试 本地接口地址
          params: {
            phone:that.form.phone,
            code: that.form.code,
          },
        }).then((res) => {
          console.log(res);
          if (res.data.code == 0) {
            alert("验证码不正确,请重新输入");
            return false;
          } else {
            //提交表单
            that.axios({
                method: "post",
                 url: this.Url.apiUrl + "SystemOption/CaseAdvisory",//线上地址
               // url:
                //  "http://test-shenzhen.api.yingkelawyer.com/api/" +
                //  "SystemOption/CaseAdvisory",             //测试 44接口地址
                data: that.form,
                headers: {
                  "Content-Type": "application/json",
                },
              })
              .then(() => {
                alert("提交成功");
                that.disabled = true;
              });
          }
        });
    },
  },
  created() {
   //根据ip获取位置
  this.axios({
      type: "get",
      url: "https://restapi.amap.com/v3/ip?key=3bf7b13d0ae511ae362948dde79bdb14",
    }).then((res) => {
     let _this = this;
     var citys=res.data.city
     _this.form.address=citys;
    });

    //添加滚动监听
    // window.addEventListener("scroll", this.handleScroll);
    //初始化路径数据
    this.$store.state.Currentposition = [
      {
        path: "/",
        name: "首页",
      },
      {
        path: "/contact.html",
        name: "联系我们",
      },
    ];
    this.loadSeo();
  },
};
</script>

<style lang="scss" scoped>
.content {
  position: relative;
  display: block;
  width: 1200px;
  margin: 0 auto;

  @media screen and (max-width: 768px) {
    width: 100%;
    padding: 26px 21px;
    overflow: hidden;
  }

  .Item-from {
    width: 100%;
    height: 320px;
    background-color: #ffffff;
    box-shadow: 0px 1px 10px 0px rgba(222, 222, 222, 0.3);
    border-radius: 5px;
    margin: 20px 0;

    // border: solid 1px #bd9d6c;
    @media screen and(max-width: 768px) {
      margin: 0;
      box-shadow: none;
      height: auto;
    }

    .Item-flex {
      display: flex;

      @media screen and(max-width: 768px) {
        display: block;
      }

      .el-form-item {
        width: 380px;
        margin: 15px auto;

        @media screen and(max-width: 768px) {
          width: 100%;
        }

        .submit {
          background: #bd9d6c;
          border-radius: 2px;
          border: 1px solid #bd9d6c;

          @media screen and (max-width: 768px) {
            margin: 0 auto;
            display: block;
          }
        }
      }
    }
  }

  .map {
    position: relative;
    display: block;
    margin: 20px 0;
    width: 100%;
    overflow: hidden;
    height: 350px;

    @media screen and (max-width: 768px) {
      margin: 40px 0;
    }

    img {
      width: 1200px;
      height: auto;

      @media screen and (max-width: 768px) {
        width: 100%;
      }
    }
  }
}
		.Icon_group {
			position: fixed;
			right: 100px;
			height: 240px;
			top: 50%;
			z-index: 99999;
			display: flex;
			justify-content: space-between;
			flex-direction: column;
			@media screen and (max-width:1300px) {
				height: 163px;				
			}
			@media screen and (max-width:768px) {
				right: 33px;	
			}
			.Icon_item {
				width: 60px;
				height: 60px;
				cursor: pointer;
				@media screen and (max-width:1300px) {
					height: 40px;	
					width: 40px;
				}
				img {
					width: 100%;
				}
			}
		}
</style>
